import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Bullet from "highcharts/modules/bullet";
import { useTranslation } from "react-i18next";

Bullet(Highcharts);

interface LivisAccuracyComparisonChartProps {
    data: any[];
    height?: number;
}

const LivisAccuracyComparisonChart: React.FC<LivisAccuracyComparisonChartProps> = ({
    data = [],
    height = 120
}: LivisAccuracyComparisonChartProps) => {

    const { t } = useTranslation()

    // Extract the first object from the array
    const accuracyData = data[0] || { livis_accuracy: null, actual_model_accuracy: null };

    // Convert to numbers safely (handles strings, nulls, undefined, etc.)
    const parseValue = (val: any) => {
        const num = parseFloat(val);
        return isNaN(num) ? null : num;
    };

    const livisVal = parseValue(accuracyData.livis_accuracy);
    const actualVal = parseValue(accuracyData.actual_model_accuracy);

    const chartData: any = [
        {
            y: livisVal === null ? null : livisVal * 100, // Livis accuracy
            target: actualVal === null ? null : actualVal * 100, // Actual model accuracy
        },
    ];

    console.log(chartData, accuracyData.livis_accuracy, !accuracyData.livis_accuracy)

    const options: Highcharts.Options = {
        chart: {
            type: "bullet",
            inverted: true,
            backgroundColor: "transparent",
            height: height,
        },
        title: { text: undefined },
        xAxis: { visible: false },
        yAxis: {
            gridLineWidth: 0,
            title: { text: undefined },
            min: 0,
            max: 100,
        },
        plotOptions: {
            series: {
                borderWidth: 0,
            },
            bullet: {
                targetOptions: {
                    width: '200%', // makes the target line (actual model) thicker
                    borderColor: "var(--livis-color-primary-dblue)"
                },
            },
        },
        legend: { enabled: false },
        tooltip: {
            useHTML: true,
            borderColor: "var(--livis-color-primary-dblue)",
            borderRadius: 6,
            backgroundColor: "#fff",
            style: { color: "#000", fontFamily: "Noto Sans Medium" },
            formatter: function () {
                const point: any = this.point;
                const livis = point.y !== null ? point.y.toFixed(2) : "N/A";
                const target = point.target !== null ? point.target.toFixed(2) : "N/A";
                return `
            <b>${t("Livis Accuracy")}:</b> ${livis}%<br/>
            <b>${t("Actual Model Accuracy")}:</b> ${target}%
        `;
            },
        },

        series: [
            {
                type: "bullet",
                name: "Livis Accuracy",
                data: chartData,
                color: "var(--livis-accent-color)",
            },
        ],
        credits: { enabled: false },
    };

    if (chartData[0].y === null && chartData[0].target === null) {
        return <div style={{ textAlign: "center", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--livis-color-primary-gray)" }}>{t("No data to display")}</div>;
    }

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default LivisAccuracyComparisonChart;